import { atom } from 'jotai';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';
import { TComment } from 'shared/models/comment';

export interface ICommentReplies {
  items: TComment[];
  offset: number;
  hasMore: boolean;
}

type TCommentRepliesStore = {
  [key: string]: ICommentReplies;
};

const $CommentRepliesStore = atom({} as TCommentRepliesStore);
$CommentRepliesStore.debugLabel = '$CommentRepliesStore';

export const $CommentReplies = safeAtomFamily((commentId: string) => {
  const a = atom(
    (get) => {
      return (
        get($CommentRepliesStore)[commentId] || {
          items: [],
          hasMore: true,
          offset: 0,
        }
      );
    },
    (get, set, input: ICommentReplies) => {
      const old = get($CommentRepliesStore);
      set($CommentRepliesStore, {
        ...old,
        [commentId]: input,
      });
    },
  );

  a.debugLabel = `$CommentReplies+${encodeURIComponent(commentId)}`;

  return a;
});

export const $CommentRepliesLoadmore = safeAtomFamily((commentId: string) => {
  const a = atom(null, async (get, set, input: ICommentReplies) => {
    const old = get($CommentReplies(commentId));

    set($CommentReplies(commentId), {
      ...input,
      items: [...old.items, ...input.items],
    });
  });

  a.debugLabel = `$CommentRepliesLoadmore+${encodeURIComponent(commentId)}`;

  return a;
});
